export default __webpack_public_path__ + "static/media/Bionic-Arm-04.f0372803.jpg";